var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.refreshSearch}},[_vm._v("検索を再表示")])}
var staticRenderFns = []

export { render, staticRenderFns }